/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Reset_SubtitleInputs */



/**
* | output |
* | --- |
* | "Enter your recovery code to log in" |
*
* @param {Auth_Reset_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_reset_subtitle = /** @type {((inputs?: Auth_Reset_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Reset_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gib deinen Wiederherstellungscode ein, um dich anzumelden")
	return /** @type {LocalizedString} */ ("Enter your recovery code to log in")
});